import React, { ReactNode } from "react"
import { Control } from "react-hook-form"
import UpgradeAlert from "components/elements/UpgradeAlert"
import BasicInputs from "./BasicInputs/BasicInputs"
import FormDetailHeader from "./FormDetailHeader"

type Props = {
  control: Control<object, any>
  eventId: string
  showUpgradeAlert: boolean
  name: string
  sendConfirmationEmails: boolean
  quantityHelperText?: ReactNode
}

const RSVP = ({
  control, eventId, showUpgradeAlert, name, sendConfirmationEmails, quantityHelperText,
}: Props) => (
  <>
    <FormDetailHeader
      name={name}
      description="Distributed via Diobox Emails, this form generates a unique link for each recipient to ensure that the RSVP is private and non-transferrable by the guest."
    />
    {showUpgradeAlert && <UpgradeAlert mb={8} maxW="full" text="Requires Professional Plan or higher" />}
    <BasicInputs
      control={control}
      eventId={eventId}
      showQuantityInput
      quantityHelperText={quantityHelperText}
      sendConfirmationEmails={sendConfirmationEmails}
    />
  </>
)

export default RSVP
